import React from "react";
import Icon from "../../_default/Icon";
import "./Profile.scss";

export default function Profile({icon, name, count, size='35px', stroke}) {
    return(
        <div className="c-profile-stat">
            <Icon icon={icon} size={size} stroke={stroke} />
            <div className="c-client-stats-container">
                <span>{count? count : "0"}</span>
                <p>{name}</p>
            </div>
        </div>
    );
}